import { css } from 'styled-components';
export const BaseTransition = css`
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
`;
